<template>
  <div>
    <div class="style-browser">
      <div id="style-col" class="browse-col">
        <div class="h2">{{ $nippets.browseByStyle}} &nbsp;<span class="gr">/</span>&nbsp;
          <span class="lc">{{ $nippets.categories}}</span>&nbsp;
                    <span class="gr">/</span>&nbsp; <span class="lc">{{ $nippets.media }}</span>
        </div>
        <div class="four-col" :class="{animsize: animation}">
          <ix-router-link v-for="gal in gals" :key="gal.gallery_id" :to="gal.url" v-html="checkAnim(gal.name)"></ix-router-link>
        </div>
      </div>
      <div id="anim-col" class="browse-col big-marge" v-if="!animation">
        <div class="h2 lt">{{ $nippets.portfolio.animation}} {{ $nippets.styles.toLowerCase() }} &nbsp;<span class="gr">/</span>&nbsp;
          <span class="lc">{{ $nippets.categories}}</span>&nbsp;
                    <span class="gr">/</span>&nbsp; <span class="lc">{{ $nippets.media }}</span>
        </div>
        <div class="four-col animsize">
          <ix-router-link v-for="gal in animgals" :key="gal.gallery_id" :to="gal.url" v-html="gal.name"></ix-router-link>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import StyleFetcher from '@/mixins/StyleFetcher.js'
export default {
  mixins: [StyleFetcher],
  methods: {
    checkAnim(aname) {
      if(!this.animation) {
        return aname
      }
      if(aname.indexOf('(') < 0) {
        return aname + ' ' + this.$nippets.animators.toLowerCase()
      }
      return aname
    }
  }
}
</script>
<style scoped>
  .four-col{
    columns:4;
    column-gap:40px;
  }

  .gr{
    color:#999;
  }

  .four-col.animsize{
    max-width:900px;
    columns:3;
    margin-left:auto;
    margin-right:auto;
  }

  .big-marge{
    margin-top:50px;
  }

  @media screen and (max-width:768px) {
    .four-col, .four-col.animsize{
      columns:2;
      column-gap:0;
    }
  }

  @media screen and (max-width:420px){
    .four-col, .four-col.animsize{
      columns:1;
      column-gap:0;
    }
  }

</style>

